import { Component, OnInit, ViewChild } from "@angular/core";
import { Utils } from "../../utils/utils";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { TipoNovedadService } from "../../servicios/tipo-novedad.service";

@Component({
  selector: "app-administracion-tipos-novedades",
  templateUrl: "./administracion-tipos-novedades.component.html",
  styleUrls: ["./administracion-tipos-novedades.component.css"],
})
export class AdministracionTiposNovedadesComponent implements OnInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger = new Subject();

  dtOptions: any = {
    pagingType: "full_numbers",
    scrollX: true,
    dom: "Bfrtip",
    buttons: [
      "colvis",
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ":visible",
        },
      },
      {
        extend: "excelHtml5",
        fileName: "CustomFileName" + ".xlsx",
        exportOptions: {
          columns: ":visible",
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true },
      },
    ],
  };

  tipoNovedades = [];
  haveData = false;
  loading = false;
  timeRunning = 0;
  isEdit = false;
  idDescEdit = "";

  tipoNovedadGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private servicioTipoNovedad: TipoNovedadService,
    private snackBar: MatSnackBar,
    public ruta: Utils
  ) {
    this.tipoNovedadGroup = this.formBuilder.group({
      formDescripcion: ["", [Validators.required, Validators.maxLength(50)]],
    });

    this.loading = true;
    this.servicioTipoNovedad.getTiposNovedades(0).subscribe((result) => {
      this.tipoNovedades = result;
      console.log(this.tipoNovedades);
      this.haveData = true;
      this.loading = false;

      if (this.timeRunning == 0) {
        this.dtTrigger.next();
      } else {
        this.reRender();
      }
      this.timeRunning++;
    });
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }

  editar(item) {
    this.idDescEdit = item.id;
    this.tipoNovedadGroup.controls["formDescripcion"].setValue(item.valor);
    this.isEdit = true;
  }

  eliminar(item) {
    const tipoNovedad = item.id;
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    const usuario = infoUsuario[0].IdUsuario;

    Swal.fire({
      title: "Eliminar Tipo Novedad?",
      text: "Esta seguro que desea eliminar este tipo novedad!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Si, Eliminar!",
    }).then((result) => {
      if (result.value) {
        this.servicioTipoNovedad
          .deleteTipoNovedad(tipoNovedad, usuario)
          .subscribe((result) => {
            this.tipoNovedadGroup.reset();
            this.isEdit = false;
            this.refrescaBusqueda();
            Swal.fire("Eliminado!", "Registro Eliminado.", "success");
          });
      }
    });
  }

  cancelarEdit() {
    this.tipoNovedadGroup.controls["formDescripcion"].setValue("");
    this.isEdit = false;
  }

  procesoAgencia() {
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    const usuarioConsulta = infoUsuario[0].IdUsuario;
    const descripcion = this.tipoNovedadGroup.controls["formDescripcion"].value;
    const params = {
      descripcion: descripcion,
      usuario: usuarioConsulta,
    };
    if (this.isEdit) {
      //es por que estoy editando
      this.servicioTipoNovedad
        .putTipoNovedad(this.idDescEdit, params)
        .subscribe((result) => {
          this.refrescaBusqueda();
          this.tipoNovedadGroup.controls["formDescripcion"].setValue("");
          this.isEdit = false;
          this.snackBar.open(
            "Tipo Novedad Actualizada",
            "Actualizar Tipo Novedad",
            {
              duration: 2000,
            }
          );
        });
    } //es por que estoy creando
    else {
      this.servicioTipoNovedad.postTipoNovedad(params).subscribe((result) => {
        this.tipoNovedadGroup.controls["formDescripcion"].setValue("");
        this.refrescaBusqueda();
        this.snackBar.open("Tipo Novedad Creada", "Crear Tipo Novedad", {
          duration: 2000,
        });
      });
    }
  }

  refrescaBusqueda() {
    this.loading = true;
    this.servicioTipoNovedad.getTiposNovedades(0).subscribe((result) => {
      this.tipoNovedades = result;
      console.log(this.tipoNovedades);
      this.haveData = true;
      this.loading = false;

      if (this.timeRunning == 0) {
        this.dtTrigger.next();
      } else {
        this.reRender();
      }
      this.timeRunning++;
    });
  }
}
